/// <reference path="../../../Modules/Attr/Grid/NoboxEntityGrid.ts" />
namespace Nobox {

    import fld = ChatroomagentsRow.Fields;
    @Serenity.Decorators.registerClass()
    export class ChatroomagentsGrid extends NoboxEntityGrid<ChatroomagentsRow, any> {
        protected getColumnsKey() { return ChatroomagentsColumns.columnsKey; }
        protected getDialogType() { return ChatroomagentsDialog; }
        protected getIdProperty() { return ChatroomagentsRow.idProperty; }
        protected getInsertPermission() { return ChatroomagentsRow.insertPermission; }
        protected getLocalTextPrefix() { return ChatroomagentsRow.localTextPrefix; }
        protected getService() { return ChatroomagentsService.baseUrl; }
        //public FieldIn: any;
        constructor(container: JQuery) {
            super(container);
        }
        protected getButtons() {
            var $this = this;
            var buttons = super.getButtons();
            buttons.splice(0, 1);
            return buttons;
        }

        protected getViewOptions() {
            let opt = super.getViewOptions();
            opt.rowsPerPage = 20;
            opt.url = Q.resolveUrl('~/Services/' + this.getService() + '/ListHandOver');
            return opt;
        }

        protected getColumns(): Slick.Column[] {
            var columns = super.getColumns();
            let listChannel = Q.getLookup("Nobox.ChannelAutomationLookup").itemById as unknown as Master.ChannelRow[];
            let listUser = Q.getLookup("Nobox.UsersLookup").itemById as unknown as Administration.UserRow[];
            let listLink = Q.getLookup("Nobox.LinkLookup").itemById as unknown as ChatlinkcontactsRow[];
            columns.unshift({
                field: 'Go To Conversation',
                name: '',
                format: ctx => {
                    return '<a href="javascript:;" title="Go to conversation"><i class="fa fa-share text-primary room-link"></i></a>';
                },
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });
            Q.first(columns, x => x.field == ChatroomagentsRow.Fields.ChId).format =
                ctx => `<a href="javascript:;" class="channel-link" data-id="${ctx.item.ChId}">${Q.htmlEncode(listChannel[ctx.value].Nm)}</a>`;
            Q.first(columns, x => x.field == ChatroomagentsRow.Fields.UserId).format =
                ctx => `<a href="javascript:;" class="agent-link" data-id="${ctx.item.UserId}">${Q.htmlEncode(listUser[ctx.value] == undefined ? "Not Found" : listUser[ctx.value].DisplayName)}</a>`;
            Q.first(columns, x => x.field == ChatroomagentsRow.Fields.HandId).format =
                ctx => `<a href="javascript:;" class="hand-over-link" data-id="${ctx.item.HandId}">${Q.htmlEncode(listUser[ctx.value] == undefined ? "Not Found" : listUser[ctx.value].DisplayName)}</a>`;
            Q.first(columns, x => x.field == ChatroomagentsRow.Fields.Ct).format =
                ctx => `<a href="javascript:;" class="link-link" data-id="${ctx.item.CtId}">${Q.htmlEncode(ctx.value)}</a>`;
            Q.first(columns, x => x.field == ChatroomagentsRow.Fields.CtReal).format =
                ctx => `<a href="javascript:;" class="contact-link" data-id="${ctx.item.CtRealId}">${Q.htmlEncode(ctx.value)}</a>`;
            //Q.first(columns, x => x.field == ChatroomagentsRow.Fields.CtId).format =
            //    ctx => {
            //        var adaLink = listLink[ctx.value];
            //        if (adaLink != undefined) {
            //            if (adaLink.CtId != null) {
            //                let listLead = Q.getLookup("Nobox.LeadLookup").itemById as unknown as Nobox.LeadRow[];
            //                var adaContact = listLead[adaLink.CtId];
            //                if (adaContact != undefined) {
            //                    return `<a href="javascript:;" class="contact-link" data-id="${adaContact.Id}">${Q.htmlEncode(listLead[adaContact.Id].Name)}</a>`
            //                } else {
            //                    return "-";
            //                }
            //            } else {
            //                return "-";
            //            }
            //        } else {
            //            return "-";
            //        }
            //    };

            return columns;
        }
        protected createSlickGrid(): Slick.Grid {
            var grid = super.createSlickGrid();
            grid.setSelectionModel(new Slick.RowSelectionModel());
            return grid;
        }
        protected onViewSubmit(): boolean {
            if (!super.onViewSubmit()) { return false; }
            let request = this.view.params as Serenity.ListRequest;
            //request.IncludeColumns = ["HanderNm", "DisplayName", "Ct", "IdExt", "ChId", "Ch", "In", "UserEmail", "LastLogin"];
            ////request.ColumnSelection = 1;
            //var $this = this;
            //if (this.FieldIn) {
            //    request.Criteria = Serenity.Criteria.and(request.Criteria, [[[ChatroomagentsRow.Fields.In], '>=', $this.FieldIn[0]], "and", [[ChatroomagentsRow.Fields.In], '<=', $this.FieldIn[1]]]);
            //}
            return true;
        }
        protected getQuickFilters() {
            var flt = super.getQuickFilters();

            var filter1 = Q.first(flt, x => x.field == ChatroomagentsRow.Fields.In);
            filter1.handler = h => {
                const request = (h.request as ChatroomagentsListRequest);
                const start = (h.widget as CustomDateFilter).get_value();
                const end = (h.widget as CustomDateFilter).end_get_value();
                if (h.active) {
                    if (start != null && end != null) {
                        request.Criteria = [[["In"], ">=", start], "and", [["In"], "<=", end]]
                    } else if (start != null) {
                        request.Criteria = [["In"], ">=", start];
                    } else if (end != null) {
                        request.Criteria = [["In"], "<=", end];
                    }
                    h.handled = true;
                } else {
                    request.Criteria = null;
                    h.handled = true;
                }
            };
            //var filter2 = Q.first(flt, x => x.field == ChatroomagentsRow.Fields.CtId);
            //filter2.handler = h => {
            //    const request = (h.request as ChatroomagentsListRequest);
            //    const val = (h.widget as Serenity.ServiceLookupEditor).get_value();
            //    if (h.active) {
            //        request.IdContact = val;
            //        h.handled = true;
            //    } else {
            //        request.IdContact = null;
            //        h.handled = true;
            //    }
            //};
            return flt;
        }
        protected onClick(e: JQueryEventObject, row: number, cell: number): void {

            // let base grid handle clicks for its edit links
            super.onClick(e, row, cell);
            // if base grid already handled, we shouldn"t handle it again
            if (e.isDefaultPrevented()) {
                return;
            }

            // get reference to current item
            var item = this.itemAt(row);

            // get reference to clicked element
            var target = $(e.target);

            if (target.hasClass("room-link")) { 
                window.open("/Messages/Inbox?RoomId=" + item.RoomId)
            }else if (target.hasClass("agent-link")) { 
                e.preventDefault();

                Q.notifySuccess("Success filter by agent");
                var agentFilter = this.findQuickFilter(Serenity.ServiceLookupEditor,
                    ChatroomagentsRow.Fields.UserId);
                agentFilter.set_value(target.attr("data-id"));
                this.refresh();
            }else if (target.hasClass("hand-over-link")) { 
                e.preventDefault();

                Q.notifySuccess("Success filter by handed over to");
                var agentFilter = this.findQuickFilter(Serenity.ServiceLookupEditor,
                    ChatroomagentsRow.Fields.HandId);
                agentFilter.set_value(target.attr("data-id"));
                this.refresh();
            }else if (target.hasClass("channel-link")) { 
                e.preventDefault();

                Q.notifySuccess("Success filter by channel");
                var agentFilter = this.findQuickFilter(Serenity.ServiceLookupEditor,
                    ChatroomagentsRow.Fields.ChId);
                agentFilter.set_value(target.attr("data-id"));
                this.refresh();
            }else if (target.hasClass("contact-link")) { 
                e.preventDefault();

                Q.notifySuccess("Success filter by contact");
                var agentFilter = this.findQuickFilter(Serenity.ServiceLookupEditor,
                    ChatroomagentsRow.Fields.CtRealId);
                agentFilter.set_value(target.attr("data-id"));
                this.refresh();
            }else if (target.hasClass("link-link")) { 
                e.preventDefault();

                Q.notifySuccess("Success filter by link");
                var agentFilter = this.findQuickFilter(Serenity.ServiceLookupEditor,
                    ChatroomagentsRow.Fields.CtId);
                agentFilter.set_value(target.attr("data-id"));
                this.refresh();
            }
        }
    }
}